module.exports = __webpack_public_path__ + "static/media/logo.e00f2114.png";